<template>
  <div class="modal fade edit-property-modal" tabindex="-1" role="dialog" aria-labelledby="editPropertyModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title text-white" id="editPropertyModalLabel">
            <i class="mdi mdi-file-document-edit me-2"></i>
            Edit Property - {{ localProperty.LRNumber }}
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs nav-tabs-custom" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" data-bs-toggle="tab" href="#basic-info" role="tab">
                <i class="mdi mdi-home-variant me-1"></i> Basic Information
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" href="#owner-info" role="tab">
                <i class="mdi mdi-account me-1"></i> Owner Details
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" href="#co-owner-info" role="tab">
                <i class="mdi mdi-account-multiple me-1"></i> Co-Owner Details
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-bs-toggle="tab" href="#financial-info" role="tab">
                <i class="mdi mdi-cash me-1"></i> Financial Information
              </a>
            </li>
          </ul>

          <!-- Tab panes -->
          <div class="tab-content p-3">
            <!-- Basic Information Tab -->
            <div class="tab-pane active" id="basic-info" role="tabpanel">
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">UPN Number <span class="text-danger">*</span></label>
                    <input v-model="localProperty.UPN" type="text" class="form-control" required>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">LR Number <span class="text-danger">*</span></label>
                    <input v-model="localProperty.LRNumber" type="text" class="form-control" required>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Zone <span class="text-danger">*</span></label>
                    <input v-model="localProperty.zone" type="text" class="form-control" required>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Sub County</label>
                    <select v-model="selectedSubCounty" @change="onSubCountyChange" class="form-select">
                      <option value="">Select Sub County</option>
                      <option v-for="subCounty in subCounties" :key="subCounty.subCountyID" :value="subCounty">
                        {{ subCounty.subCountyName }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Ward</label>
                    <select v-model="selectedWard" @change="onWardChange" class="form-select">
                      <option value="">Select Ward</option>
                      <option v-for="ward in localWards" :key="ward.wardID" :value="ward">
                        {{ ward.wardName }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Block</label>
                    <select v-model="localProperty.block" class="form-select">
                      <option value="">Select Block</option>
                      <option v-for="block in blocks" :key="block.id" :value="block.block">
                        {{ block.block }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Land Use</label>
                    <select v-model="localProperty.useName" class="form-select">
                      <option value="">Select Land Use</option>
                      <option v-for="use in uses" :key="use.id" :value="use.name">
                        {{ use.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Parcel Size (Ha)</label>
                    <input v-model="localProperty.percelSize" type="number" step="0.01" class="form-control">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Status</label>
                    <select v-model="localProperty.status" class="form-select">
                      <option value="Active">Active</option>
                      <option value="Suspended">Suspended</option>
                      <option value="Rate Struck">Rate Struck</option>
                      <option value="Subdivided">Subdivided</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Physical Address</label>
                    <textarea v-model="localProperty.percelAddress" class="form-control" rows="2"></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Latitude</label>
                    <input v-model="localProperty.lat" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Longitude</label>
                    <input v-model="localProperty.lng" type="text" class="form-control">
                  </div>
                </div>
              </div>
            </div>

            <!-- Owner Details Tab -->
            <div class="tab-pane" id="owner-info" role="tabpanel">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Owner Names <span class="text-danger">*</span></label>
                    <input v-model="localProperty.ownerNames" type="text" class="form-control" required>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">ID Number</label>
                    <input v-model="localProperty.ownerID" type="text" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Phone Number</label>
                    <input v-model="localProperty.ownerPhoneNo" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Email Address</label>
                    <input v-model="localProperty.ownerEmail" type="email" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">PIN Number</label>
                    <input v-model="localProperty.pinNumber" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Passport Number</label>
                    <input v-model="localProperty.ownerPassport" type="text" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Driving License</label>
                    <input v-model="localProperty.ownerDrivingLicence" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Registration Certificate</label>
                    <input v-model="localProperty.registrationCertificate" type="text" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">P.O. Box</label>
                    <input v-model="localProperty.boxNo" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Postal Code</label>
                    <input v-model="localProperty.postalCode" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Town</label>
                    <input v-model="localProperty.town" type="text" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Physical Address</label>
                    <textarea v-model="localProperty.physicalAddress" class="form-control" rows="2"></textarea>
                  </div>
                </div>
              </div>
            </div>

            <!-- Co-Owner Details Tab -->
            <div class="tab-pane" id="co-owner-info" role="tabpanel">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Co-Owner Names</label>
                    <input v-model="localProperty.coOwnerNames" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Co-Owner ID</label>
                    <input v-model="localProperty.coOwnerID" type="text" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Co-Owner Phone</label>
                    <input v-model="localProperty.coOwnerPhoneNo" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Co-Owner Email</label>
                    <input v-model="localProperty.coOwnerEmail" type="email" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Co-Owner PIN</label>
                    <input v-model="localProperty.coOwnerPinNumber" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Co-Owner Passport</label>
                    <input v-model="localProperty.coOwnerPassport" type="text" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Co-Owner P.O. Box</label>
                    <input v-model="localProperty.coOwnerBoxNo" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Co-Owner Postal Code</label>
                    <input v-model="localProperty.coOwnerPostalCode" type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="form-label">Co-Owner Town</label>
                    <input v-model="localProperty.coOwnerTown" type="text" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Co-Owner Physical Address</label>
                    <textarea v-model="localProperty.coOwnerPhysicalAddress" class="form-control" rows="2"></textarea>
                  </div>
                </div>
              </div>
            </div>

            <!-- Financial Information Tab -->
            <div class="tab-pane" id="financial-info" role="tabpanel">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Annual Land Rates</label>
                    <input v-model="localProperty.annualLandRates" type="number" step="0.01" class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Annual Ground Rent</label>
                    <input v-model="localProperty.annualGroundRent" type="number" step="0.01" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Land Rates Arrears</label>
                    <input v-model="localProperty.landRatesArrears" type="number" step="0.01" class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Ground Rent Arrears</label>
                    <input v-model="localProperty.groundRentArrears" type="number" step="0.01" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Accumulated Penalty</label>
                    <input v-model="localProperty.accumPenalty" type="number" step="0.01" class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Accumulated Interest</label>
                    <input v-model="localProperty.accumInterest" type="number" step="0.01" class="form-control">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Total Payments</label>
                    <input v-model="localProperty.payments" type="number" step="0.01" class="form-control" readonly>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Current Balance</label>
                    <input v-model="computedBalance" type="number" step="0.01" class="form-control" readonly>
                  </div>
                </div>
              </div>

              <!-- Calculated Totals -->
              <div class="alert alert-info">
                <h6>Calculated Totals:</h6>
                <div class="row">
                  <div class="col-md-6">
                    <strong>Total Annual Charges:</strong> KES {{ numberFormat(totalAnnualCharges) }}
                  </div>
                  <div class="col-md-6">
                    <strong>Total Arrears:</strong> KES {{ numberFormat(totalArrears) }}
                  </div>
                  <div class="col-md-6">
                    <strong>Total Penalties & Interest:</strong> KES {{ numberFormat(totalPenaltiesAndInterest) }}
                  </div>
                  <div class="col-md-6">
                    <strong>Net Balance:</strong> KES {{ numberFormat(computedBalance) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button @click="validateAndSubmit" type="button" class="btn btn-primary" :disabled="saving">
            <span v-if="saving">
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Saving...
            </span>
            <span v-else>
              <i class="mdi mdi-content-save me-2"></i>
              Save Changes
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { execute, landRate } from "@/api";

export default {
  name: "EditPropertyModal",
  props: {
    property: {
      type: Object,
      default: () => ({})
    },
    blocks: {
      type: Array,
      default: () => []
    },
    uses: {
      type: Array,
      default: () => []
    },
    subCounties: {
      type: Array,
      default: () => []
    },
    wards: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localProperty: {},
      selectedSubCounty: null,
      selectedWard: null,
      localWards: [],
      saving: false
    };
  },
  computed: {
    totalAnnualCharges() {
      return (parseFloat(this.localProperty.annualLandRates) || 0) +
          (parseFloat(this.localProperty.annualGroundRent) || 0);
    },
    totalArrears() {
      return (parseFloat(this.localProperty.landRatesArrears) || 0) +
          (parseFloat(this.localProperty.groundRentArrears) || 0);
    },
    totalPenaltiesAndInterest() {
      return (parseFloat(this.localProperty.accumPenalty) || 0) +
          (parseFloat(this.localProperty.accumInterest) || 0);
    },
    computedBalance() {
      const totalOwed = this.totalArrears + this.totalPenaltiesAndInterest;
      const payments = parseFloat(this.localProperty.payments) || 0;
      return totalOwed - payments;
    }
  },
  watch: {
    property: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.localProperty = { ...newVal };
          this.initializeSelections();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initializeSelections() {
      // Set selected sub-county
      if (this.localProperty.subCountyID) {
        this.selectedSubCounty = this.subCounties.find(
            sc => sc.subCountyID === this.localProperty.subCountyID
        );
        if (this.selectedSubCounty) {
          this.$emit('get-wards', this.selectedSubCounty.subCountyID);
        }
      }

      // Set selected ward
      if (this.localProperty.wardID) {
        this.selectedWard = this.wards.find(
            w => w.wardID === this.localProperty.wardID
        );
      }
    },

    onSubCountyChange() {
      if (this.selectedSubCounty) {
        this.localProperty.subCountyID = this.selectedSubCounty.subCountyID;
        this.localProperty.subCountyName = this.selectedSubCounty.subCountyName;
        this.$emit('get-wards', this.selectedSubCounty.subCountyID);
        this.selectedWard = null;
        this.localProperty.wardID = '';
        this.localProperty.wardName = '';
      }
    },

    onWardChange() {
      if (this.selectedWard) {
        this.localProperty.wardID = this.selectedWard.wardID;
        this.localProperty.wardName = this.selectedWard.wardName;
      }
    },

    numberFormat(num) {
      const formatter = new Intl.NumberFormat("en-GB");
      return formatter.format(num);
    },

    validateAndSubmit() {
      // Basic validation
      if (!this.localProperty.UPN || !this.localProperty.LRNumber) {
        alert("UPN and LR Number are required fields");
        return;
      }

      if (!this.localProperty.ownerNames) {
        alert("Owner name is required");
        return;
      }

      if (!this.localProperty.zone) {
        alert("Zone is required");
        return;
      }

      // Submit the update
      this.submitUpdate();
    },

    submitUpdate() {
      this.saving = true;

      const data = new FormData();
      data.append("function", "updateProperty");
      data.append("propertyID", this.localProperty.id);

      // Add all property fields
      Object.keys(this.localProperty).forEach(key => {
        if (this.localProperty[key] !== null && this.localProperty[key] !== undefined) {
          data.append(key, this.localProperty[key]);
        }
      });

      // Add session info
      data.append("updatedBy", sessionStorage.getItem("sessionNames"));
      data.append("updatedByIDNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, landRate)
          .then((res) => {
            this.saving = false;
            if (res.data.success) {
              alert("Property updated successfully");
              this.$emit('property-updated');

              // Close modal
              const modal = document.querySelector('.edit-property-modal');
              if (modal) {
                const modalInstance = bootstrap.Modal.getInstance(modal);
                if (modalInstance) {
                  modalInstance.hide();
                }
              }
            } else {
              alert("Update failed: " + res.data.message);
            }
          })
          .catch((e) => {
            this.saving = false;
            alert("Error updating property: " + e.message);
          });
    }
  }
};
</script>

<style scoped>
.nav-tabs-custom .nav-link {
  color: #495057;
  font-weight: 500;
}

.nav-tabs-custom .nav-link.active {
  color: #007bff;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}

.tab-content {
  border: 1px solid #dee2e6;
  border-top: none;
  background-color: #fff;
}
</style>